
export enum SelectedPartnerTab {
  Statistics = 'Statistics',
  Partnership = 'Partnership'
}
